import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button, { ButtonTypes } from 'components/common/button';
import connect from 'components/lib/connect';
import { EndpointTypes } from 'models/endpoint';
import { getAgentChannelProviders, getAgentChannels } from 'components/page_layout/lib/agent_channels';
import GetNextConversation from 'actions/conversation/get_next_conversation';
import MessagingStatusButton from './agent_status/messaging_status_button';
import NonInteractiveStatusButton from './agent_status/non_interactive_status_button';
import TaskStatusButton from './agent_status/task_status_button';
import track from 'scripts/presentation/components/lib/track';
import VoiceStatusButton from './agent_status/voice_status_button';

export function AgentChannelStatusControls({
  channels,
  isMessagingEnabled,
  isNextButtonDisabled,
  isTaskUser,
  isVoiceEnabled,
  onNext,
}) {
  return (
    <div className="agentStatus">
      {renderChannelAvailabilityControls()}
      <Button
        blurOnClick
        buttonType={ButtonTypes.PRIMARY}
        className="agentStatus-next-button"
        disabled={isNextButtonDisabled}
        onClick={track.click('agentStatus-next', onNext)}
      >
        Next
      </Button>
    </div>
  );

  function renderChannelAvailabilityControls() {
    if (isTaskUser) {
      return <TaskStatusButton />;
    }

    return (
      <React.Fragment>
        <NonInteractiveStatusButton channels={channels} />
        {isVoiceEnabled ? <VoiceStatusButton /> : null}
        {isMessagingEnabled ? <MessagingStatusButton channels={channels} /> : null}
      </React.Fragment>
    );
  }
}

AgentChannelStatusControls.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.oneOf(_.values(EndpointTypes))).isRequired,
  isNextButtonDisabled: PropTypes.bool.isRequired,
  isMessagingEnabled: PropTypes.bool.isRequired,
  isVoiceEnabled: PropTypes.bool.isRequired,
  isTaskUser: PropTypes.bool.isRequired,
  onNext: PropTypes.func,
};

export default connect(mapStateToProps, mapExecuteToProps)(AgentChannelStatusControls);

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  const agentChannelProviders = getAgentChannelProviders(getProvider);
  const channels = getAgentChannels(agentChannelProviders);
  const isMessagingEnabled = !_(channels)
    .intersection([
      EndpointTypes.CHAT,
      EndpointTypes.FB_MESSENGER,
      EndpointTypes.SMS,
      EndpointTypes.WHATSAPP,
      EndpointTypes.TWITTER,
    ])
    .isEmpty();
  const preferencesProvider = getProvider('agentRoutingPreferences');
  const preferences = preferencesProvider.getPending() || preferencesProvider.get();
  const isNextButtonDisabled = !_.some(preferences.channels);

  const channelConfiguration = getProvider('channelConfiguration').get();
  const isVoiceEnabled = channelConfiguration ? channelConfiguration.companyPhoneNumbers().length !== 0 : false;
  const isTaskUser = !isFeatureEnabled('externalAgentActions') && isFeatureEnabled('internalAgentActions');

  return {
    channels,
    isNextButtonDisabled,
    isMessagingEnabled,
    isVoiceEnabled,
    isTaskUser,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onNext: () => executeAction(GetNextConversation),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/page_layout/agent_channel_status_controls.jsx